












import { Component, Watch } from 'vue-property-decorator';

import AnketaForm from '@/components/AnketaForm';

import FormApi from '@/api/FormApi';

import { isNil, isEmpty, uniq } from 'lodash';
function isEmptyOrIsNil($el: any): boolean {
   return isNil($el) || isEmpty($el) || $el == 'Invalid date';
}

// @ts-ignore
import { UrlParser } from 'url-params-parser';

import { APP_PROD } from '@/config';

@Component({
   computed: {
      inIframe() {
         if (!APP_PROD) return true;

         try {
            return window.self !== window.top;
         } catch (e) {
            return true;
         }
      },
   },
})
export default class App extends AnketaForm {
   inIframe!: boolean;

   schema: any = {
      fields: [],
   };

   model: any = {};

   formOptions!: any;

   api_key: string = '';

   result: string = '';

   mounted(): void {
      super.mounted();

      if (this.inIframe) {
         this.init();
      }

      this.inputEvents();
   }

   init(): void {
      this.clear();

      const params = UrlParser(window.location.href).queryParams;

      this.api_key = params?.api_key;

      if (params.lang) {
         const lang = params.lang.substr(0, 2);

         if (this.$i18n.messages[lang]) {
            this.$i18n.locale = lang;
         }
      }
   }

   initSchema() {
      this.schema = {
         fields: [
            {
               type: 'input',
               inputType: 'text',
               label: this.$t('forms.embed.name'),
               model: 'name',
               validator: [this.validatorRequired],
            },
            {
               type: 'radios',
               model: 'type',
               values: [
                  {
                     name: this.$t('forms.embed.type.individual'),
                     value: 'Individual',
                  },
                  {
                     name: this.$t('forms.embed.type.legal'),
                     value: 'Legal',
                  },
               ],
               validator: [this.validatorRequired],
            },
            {
               type: 'checkbox',
               label:
                  this.$t('forms.embed.vid-' + (this.model?.type ?? 'Individual')) +
                  (this.model?.type == 'Individual' ? '<small>' + this.$t('forms.embed.vid_tooltip') + '</small>' : ''),
               fieldClasses: 'form-check-input',
               styleClasses: 'form-check ' + (this.model.vid ? 'checked' : 'empty-field'),
               model: 'vid',
               visible: () => this.model?.type,
            },
            {
               type: 'input',
               inputType: 'text',
               label: this.$t('forms.embed.registration_code'),
               model: 'registration_code',
               validator: [this.validatorRequired, this.validatorCompanyId],
               visible: () => this.model.vid && this.model?.type === 'Legal',
            },
            {
               type: 'input',
               inputType: 'text',
               label: this.$t('forms.embed.personal_code'),
               model: 'personal_code',
               validator: [this.validatorRequired, this.validatorLicenceId],
               visible: () => this.model.vid && this.model?.type !== 'Legal',
            },
            {
               type: 'input',
               inputType: 'text',
               label: this.$t('forms.embed.email'),
               model: 'email',
               validator: [this.validatorRequired, this.validatorEmail],
            },
            {
               type: 'checkbox',
               label: this.$t('forms.embed.privacy_policy'),
               fieldClasses: 'form-check-input',
               styleClasses: 'form-check ' + (this.model.privacy_policy ? 'checked' : 'empty-field'),
               model: 'privacy_policy',
               validator: [this.validatorRequired],
            },
            {
               type: 'checkbox',
               label: this.$t('forms.embed.subscription'),
               fieldClasses: 'form-check-input',
               styleClasses: 'form-check ' + (this.model.news_subscription ? 'checked' : 'empty-field'),
               model: 'subscription',
            },
         ],
      };
   }

   inputEvents() {
      const clickOrFocus = (e: Event) => {
         const $el = e.target as HTMLElement;
         const $gr = $el.closest('.form-group') as HTMLElement;

         if ($gr) {
            const name = $gr.className.split(' ');
            const value = ($el as HTMLInputElement).value;

            if (!isEmptyOrIsNil(value)) {
               name.push('selected');
            }

            name.push('mouseover');

            $gr.className = uniq(name).join(' ');
         }
      };

      const onChange = (e: Event) => {
         const $el = e.target as HTMLElement;
         const $gr = $el.closest('.form-group') as HTMLElement;

         if ($gr && ($el instanceof HTMLInputElement || $el instanceof HTMLSelectElement)) {
            const value = ($el as HTMLInputElement).value;
            let name = $gr.className.split(' ');

            if ($el.type == 'checkbox' && ($el as HTMLInputElement).checked) {
               name.push('selected', 'checked');
            } else if ($el.type != 'checkbox' && !isEmptyOrIsNil(value)) {
               name.push('selected');
            } else {
               name = name.filter(c => !['selected', 'checked'].includes(c));
            }

            $gr.className = uniq(name).join(' ');
         }
      };

      document.addEventListener('click', clickOrFocus);

      document.addEventListener('focusin', clickOrFocus);

      document.addEventListener('input', onChange);

      document.addEventListener('change', onChange);

      document.addEventListener('focusout', (e: Event) => {
         const $el = e.target as HTMLElement;
         const $gr = $el.closest('.form-group') as HTMLElement;

         if ($gr) {
            const name = $gr.className.split(' ');

            if ($gr && ($el instanceof HTMLInputElement || $el instanceof HTMLSelectElement)) {
               const value = ($el as HTMLInputElement).value;

               if (!isEmptyOrIsNil(value)) {
                  name.push('selected');
               }
            }

            $gr.className = uniq(name.filter(c => !['mouseover'].includes(c))).join(' ');
         }
      });
   }

   onSubmit() {
      this.windowParentEvent('click-submit');

      ((this.$refs.vfg as any).validate() as Promise<any>).then((errors: any[]) => {
         if (!errors.length) {
            this.postForm();
         }
      });
   }

   postForm() {
      this.windowParentEvent('before-submit');

      const loading = this.$loading.show();
      FormApi.check_person(
         {
            ...this.model,
            dob: '',
            code: this.model.type == 'Individual' ? this.model.personal_code : this.model.registration_code,
         },
         this.api_key
      )
         .then(({ message }) => {
            this.result = message;
            this.$bvModal.show('result');
         })
         .finally(() => {
            loading.hide();
            this.windowParentEvent('after-submit');
         });
   }

   clear() {
      this.model = {
         name: '',
         email: '',
         type: null,
         vid: false,
         registration_code: '',
         personal_code: '',
      };

      this.schema = {
         fields: [],
      };

      this.result = '';

      setTimeout(() => this.initSchema(), 250);
   }

   windowParentEvent(event_id: string) {
      if (window.parent) {
         window.parent.postMessage(
            {
               event_id,
            },
            '*'
         );
      }
   }

   @Watch('model.type')
   onChangeType() {
      this.initSchema();
   }
}
